import isNil from 'lodash/isNil';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Link from 'react-router/lib/Link';
import Icon, { GLYPHS } from '../../icon';
import { t } from '../../../../modules/infra/i18n';

const HeaderDropdown = ({ title, off, isOn, toggle, items }) => (
  <div data-automation-id="brand-settings-dropdown-menu" className="c-header-primary__item u-position-relative">
    <button
      data-automation-id="header-nav-button"
      type="button"
      className={classnames('c-header-primary__dropdown js-toggle', { 'is-active': isOn })}
      onClick={toggle}
    >
      <div
        className="c-heading c-heading--light u-mr-- u-visible-inline-block-for-medium-and-up"
      >
        {title}
      </div>
      <Icon glyph={GLYPHS.arrowCircle} size="medium" className="c-dropdown-icon" />
    </button>
    <div
      data-automation-id="header-nav-list"
      className={classnames('c-header-primary-menu', { 'is-active': isOn })}
    >
      <ul className="c-separator-list">
        {items.map((item) => {
          const ItemComponent = item.component || Link;
          const WrapperComponent = item.wrapper || 'div';
          return (
            <li
              className="c-separator-list__item c-separator-list__item--header"
              key={item.label}
              display-if={!isNil(item.displayIf) ? item.displayIf : true}
            >
              <WrapperComponent>
                <ItemComponent
                  to={item.to}
                  onlyActiveOnIndex={
                    isNil(item.onlyActiveOnIndex)
                      ? true
                      : item.onlyActiveOnIndex
                  }
                  className="c-header-primary-menu__link u-flex u-align-items-center"
                  onClick={off}
                  activeClassName="c-header-primary-menu__link is-active"
                >
                  {item.label}

                  {item.isNew && (
                    <span
                      className="c-header-primary-menu-new-label"
                    >
                      {t('settings:menu_label.new')}
                    </span>
                  )}
                </ItemComponent>
              </WrapperComponent>
            </li>
          );
        })}
      </ul>
    </div>
  </div>
);
HeaderDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  isOn: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    wrapper: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.func,
    ]),
    component: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.func,
    ]),
  })).isRequired,
};
export default HeaderDropdown;
